export function StatCard({ icon: Icon, label, value, hint, accent = "orange", testId }) {
  const accents = {
    orange: "text-orange-400 bg-orange-500/10 ring-orange-500/20",
    emerald: "text-emerald-400 bg-emerald-500/10 ring-emerald-500/20",
    sky: "text-sky-400 bg-sky-500/10 ring-sky-500/20",
    rose: "text-rose-400 bg-rose-500/10 ring-rose-500/20",
    violet: "text-violet-400 bg-violet-500/10 ring-violet-500/20",
  };
  return (
    <div
      data-testid={testId}
      className="rounded-xl border border-slate-800 bg-slate-900 p-5 transition-colors hover:border-slate-700"
    >
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">
            {label}
          </p>
          <p className="mt-2 font-mono text-2xl sm:text-3xl font-extrabold tracking-tight text-white tabular">
            {value}
          </p>
          {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
        </div>
        {Icon && (
          <div className={`rounded-lg p-2.5 ring-1 ${accents[accent]}`}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </div>
  );
}
